import React from 'react';

const Card = ({ id, title, description, icon, isActive, onMouseDown, onMouseUp, onTouchStart, onTouchEnd }) => {
    const titleLines = title.split('\n'); // Split title by newline

    return (
        <>
            <style>
                {`
                    .card-flex {
                        display: flex; /* Use flexbox */
                        flex-direction: column; /* Stack children vertically */
                        justify-content: space-between; /* Evenly space children */
                        width: 250px; /* Fixed width */
                        height: 250px; /* Fixed height to maintain square shape */
                        padding: 2rem;
                        background-color: #f8f9fa;
                        border-radius: 10px;
                        box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.2);
                        text-align: center;
                        transition: transform 0.5s;
                        cursor: pointer;
                        font-size: 14px; /* Fixed font size */
                    }
                    .card-flex h4 {
                        font-size: 40px; /* Fixed title font size */
                        overflow-wrap: break-word; /* Allow words to break to next line */
                        line-height: 1.2; /* Adjust line height for better readability */
                    }
                    .card-flex p {
                        font-size: 20px; /* Fixed description font size */
                        overflow-wrap: break-word; /* Allow words to break to next line */
                        line-height: 1.2; /* Adjust line height for better readability */
                    }
                `}
            </style>
            <div
                className={`card-flex ${isActive ? 'active' : ''}`}
                onMouseDown={onMouseDown}
                onMouseUp={onMouseUp}
                onTouchStart={onTouchStart}
                onTouchEnd={onTouchEnd}
            >
                <h4>
                    {titleLines.map((line, index) => (
                        <span key={index}>
                            {line}
                            {index < titleLines.length - 1 && <br />} {/* Add line break except for the last line */}
                        </span>
                    ))}
                </h4>
                <p>{description}</p>
                <img
                    src={`./${icon}`}
                    alt={title}
                    style={{
                        height: '30px',
                        objectFit: 'contain',
                        marginTop: 'auto', // Push the image to the bottom
                        alignSelf: 'flex-start', // Aligns the image to the left
                    }}
                />
            </div>
        </>
    );
};

export default Card;
